import { setupClassicCheckoutListeners } from "../../store/storeListeners";
import $ from "jquery";
import {
	isPayForOrder,
	isPayoneerGatewaySelected,
	submitOrderPayViaAjax,
	focusOnSelectedGateway
} from "../woocommerce";
import { PAYONEER_STORE_KEY } from "../../store";
import { defaultHooks } from '@wordpress/hooks';
import { select, dispatch } from '@wordpress/data';
import { releaseOnHoldOrder, setOnPaymentDeclinedNonce } from "../../store/actions";
import { getComponentNameByGatewayId } from "../components";


export const initPaymentCheckout = () => {
	console.log('Loading payment checkout integration')

	document.addEventListener(
		'DOMContentLoaded',
		() => {
			setupClassicCheckoutListeners()
			dispatch(PAYONEER_STORE_KEY).
				setOnPaymentDeclinedNonce(PayoneerData.onPaymentDeclinedNonce);

			const $orderReviewForm = $( '#order_review' );

			defaultHooks.addFilter(
				'payoneer.webSdk.onSdkError',
				'payoneer/paymentCheckout',
				( isResolved, checkout, component, data ) => {
					const { payOrderErrorFlag } = window.PayoneerData;
					const url = new URL( document.location );
					url.searchParams.set( payOrderErrorFlag, true );
					window.location.href = url.toString();
					return isResolved;
				}
			);

			wp.hooks.addFilter(
				'payoneer.webSdk.onPaymentDeclined',
				'payoneer/paymentCheckout',
				async () => {
					await wp.data.dispatch(PAYONEER_STORE_KEY).releaseOnHoldOrder(
						{
							longId: select( PAYONEER_STORE_KEY ).getLongId(),
							orderKey: new URLSearchParams(window.location.search).get('key'),
						},
					);
					window.location.reload();
					return false;
				}
			);

			$orderReviewForm.on( 'submit', ( e ) => {
				if ( !isPayoneerGatewaySelected() || select( PAYONEER_STORE_KEY ).isHostedModeForced() ) {
					return;
				}

				e.preventDefault();
				e.stopImmediatePropagation();

				const payoneerStore = select( PAYONEER_STORE_KEY );
				const componentName = getComponentNameByGatewayId(payoneerStore.getActivePaymentMethod());

				const isValid = payoneerStore.getIsValidForComponent(componentName);

				if ( !isValid ) {
					try {
						focusOnSelectedGateway();
					} catch (error){
						console.error(error);
					} finally {
						return;
					}

				}

				submitOrderPayViaAjax( $orderReviewForm )
					.then( () => dispatch( PAYONEER_STORE_KEY ).pay() )
					.catch( () => {
						/**
						 * Reloading enables us to see error messages added via wc_add_notice()
						 * Scrolling up makes sure the notices are in the viewport after the refresh
						 */
						window.scrollTo( 0, 0 );
						window.location.reload();
					} );
			} );

			dispatch( PAYONEER_STORE_KEY ).mountComponents();
		},
		false
	);
}
